export const formatApiError = (error: string | { detail: string }): string => {
  if (typeof error === 'string') {
    return error
  }

  return error.detail || JSON.stringify(error)
}
